
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

interface BusinessFieldsProps {
  form: UseFormReturn<any>;
}

export function BusinessFields({ form }: BusinessFieldsProps) {
  const isBusiness = form.watch("isBusiness");
  
  console.log("=== BUSINESS FIELDS DEBUG ===");
  console.log("isBusiness watched value:", isBusiness);
  console.log("businessName watched value:", form.watch("businessName"));
  console.log("=== END BUSINESS FIELDS DEBUG ===");

  return (
    <>
      <FormField
        control={form.control}
        name="isBusiness"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
            <FormControl>
              <Checkbox
                checked={field.value === true}
                onCheckedChange={(checked) => {
                  console.log("=== BUSINESS CHECKBOX CHANGE ===");
                  console.log("Checkbox checked value:", checked);
                  console.log("Checkbox checked type:", typeof checked);
                  console.log("Field value before change:", field.value);
                  console.log("Field value type before change:", typeof field.value);
                  
                  // Ensure we always set a boolean value
                  const booleanValue = checked === true;
                  field.onChange(booleanValue);
                  
                  console.log("Field value after change:", form.getValues("isBusiness"));
                  console.log("Field value type after change:", typeof form.getValues("isBusiness"));
                  console.log("Form watch isBusiness after change:", form.watch("isBusiness"));
                  
                  // Clear business name if unchecking business option
                  if (!booleanValue) {
                    form.setValue("businessName", "");
                    console.log("Cleared business name since not a business");
                  }
                  
                  // Additional validation
                  const finalValue = form.getValues("isBusiness");
                  if (checked === true && finalValue !== true) {
                    console.error("❌ CRITICAL: Business checkbox checked but form value not true!");
                  } else if (checked === true && finalValue === true) {
                    console.log("✅ SUCCESS: Business checkbox properly set to true");
                  }
                  
                  console.log("=== END BUSINESS CHECKBOX CHANGE ===");
                }}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>Business Subscription</FormLabel>
              <FormDescription>
                Check this if this is a business subscription (£20/week or £840/year)
              </FormDescription>
            </div>
          </FormItem>
        )}
      />

      {isBusiness && (
        <FormField
          control={form.control}
          name="businessName"
          rules={{ 
            required: isBusiness ? "Business name is required for business subscriptions" : false 
          }}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Business Name *</FormLabel>
              <FormControl>
                <Input 
                  placeholder="Enter business name" 
                  {...field}
                  onChange={(e) => {
                    console.log("=== BUSINESS NAME CHANGE ===");
                    console.log("Business name input value:", e.target.value);
                    console.log("Business name input length:", e.target.value.length);
                    console.log("Business name input truthy:", !!e.target.value);
                    
                    field.onChange(e);
                    
                    console.log("Form business name after change:", form.getValues("businessName"));
                    console.log("Form business name type after change:", typeof form.getValues("businessName"));
                    console.log("=== END BUSINESS NAME CHANGE ===");
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
}
